import React from 'react';
import { SCREEN_XS, SCREEN_SM_MAX, SCREEN_MD_MAX } from '../../lib/ui/breakpoints';
import { getSourceElements, getSrcSet } from './imgUtils';
import { AnimationWrapper, LogosWrapper, StyledImage } from './Logos.styles';

export type LogosProps = {
  logos: {
    mobileSrc: string;
    tabletSrc: string;
    desktopSrc: string;
    imgType: string;
  }[];
  /* number of seconds for the loop, defaults to 20 seconds */
  animationSpeed?: number;
};

const Logos = (props: LogosProps): JSX.Element => {
  const { logos, animationSpeed = 20 } = props;

  const getLogos = () => {
    return logos.map((logo, i) => {
      const imageDetails = [
        { url: logo.mobileSrc, breakpoint: SCREEN_XS.toString() },
        { url: logo.tabletSrc, breakpoint: SCREEN_SM_MAX.toString() },
        { url: logo.desktopSrc, breakpoint: SCREEN_MD_MAX.toString() },
      ];
      return (
        <picture key={i}>
          {getSourceElements(imageDetails, logo.imgType)}
          <StyledImage src={logo.tabletSrc} srcSet={getSrcSet(imageDetails)} alt="" />
        </picture>
      );
    });
  };

  return (
    <LogosWrapper>
      <AnimationWrapper animationSpeed={animationSpeed}>{getLogos()}</AnimationWrapper>
      {/* In order to create the illusion of an infinitely scrolling animation, we need to have two sets of all the elements */}
      <AnimationWrapper animationSpeed={animationSpeed} aria-hidden="true">
        {getLogos()}
      </AnimationWrapper>
    </LogosWrapper>
  );
};

export default Logos;
